<template>
    <div class="login-container" >
        <div class="login-banner">
            <p class="title">请先注册&登录</p>
            <p class="title">再进行下一步操作</p>
            <p class="desc">{{hosptailName||$t("login.txt2")}}</p>
        </div>
        <div class="login-form">
            <van-form ref="loginForm" class="form-container">
                <div class="form-item">
                    <img src="@/assets/user/account-icon.png" class="icon" >
                    <van-field v-model="loginForm.tel" type="tel" :rules="formRules.tel" maxlength="11" :placeholder="$t('login.pleasephone')" />
                </div>
                <div class="form-item" v-show="loginType == 1">
                    <img src="@/assets/user/password-icon.png" class="icon" >
                    <van-field v-model="loginForm.pw" :type="PwType?'password':'text'" :placeholder="$t('login.pleasePw')" />
                    <img class="cipher" src="@/assets/user/cipher-icon.png" @click="PwType = !PwType" v-show="PwType">
                    <img class="cipher" src="@/assets/user/no-cipher-icon.png" @click="PwType = !PwType" v-show="!PwType">
                </div>
                <div class="form-item" v-show="loginType == 2">
                    <img src="@/assets/user/yzm-icon.png" class="icon" >
                    <van-field v-model="loginForm.telVerifyCode" type="digit" maxlength="6" :placeholder="$t('login.pleaseverificationCode')" />
                    <p class="verify-box" @click="sendverify">{{verificationText}}</p>
                </div>
                <div class="form-btn">
                    <van-button
                        type="primary"
                        :color="
                            !isPhoneNumber(loginForm.tel)||(loginType == 1?!loginForm.pw:!loginForm.telVerifyCode) ? 'linear-gradient(180deg, #91E3FF 0%, #49A7FF 100%)' : 'linear-gradient(#499FFF,#49A5FF,#49C1FF)'
                        "
                        :disabled="!isPhoneNumber(loginForm.tel)||(loginType == 1?!loginForm.pw:!loginForm.telVerifyCode)"
                        @click="goLogin"
                        >
                        <!-- @click="loginFun" -->
                        {{$t("user.loginTxt")}}
                    </van-button>
                </div>
                <div class="form-verify-login" v-if="$i18n.locale != 'cxo'">
                    <!-- <p  v-show="loginType == 1" @click="loginType = 2">{{$t("login.verifyLogin")}}</p>
                    <p  v-show="loginType == 2" @click="loginType = 1">{{$t("login.pwLogin")}}</p> -->
                    <p> </p>
                    <p @click="goRegist"> {{$t("login.registered")}}</p>
                </div>
            </van-form>
        </div>
        <p class="agrment-bottom-txt" v-if="argeementTitle || privacyTitle">
            <span>登录即代表您已阅读并同意</span>
            <a @click="seeTreaty(1)" v-if="argeementTitle">《{{argeementTitle}}》</a>
            <a @click="seeTreaty(2)" v-if="privacyTitle">《{{privacyTitle}}》</a>
        </p>
        <agreement-popup v-if="popupShowNum == 1" :overSubmit="callbackSubmit"></agreement-popup>
        <verification ref="childverification" :tel="loginForm.tel" v-if="verciftionShow" :verciftionclose="verciftionclose"/>
    </div>
</template>

<script>
import { isPhoneNumber } from "@/utils/vaildate"
import { config_get, verifyCode, reg_check,loginPw } from "@/api/user";
import verification from '@/components/verification.vue';
import md5 from '@/utils/md5';
import agreementPopup from "./agreementPopup"
import { throttle } from "@/utils/common";
import _ from 'lodash';
let that;
export default {
    components:{ verification, agreementPopup },
    data () {
        return {
            // 支持只出现一次弹窗
            popupShowNum:0,
            formRules:{
                tel:[
                    {
                        required: true,
                        trigger:"blur",
                        pattern:/^1\d{10}$/,
                    },
                ],
            },
            verificationText: this.$t("login.sendverificatCode"),
            argeementTitle:"",
            privacyTitle:"",
            tickType:false,
            hosptailName:"",
            loginForm:{
                telVerifyCode:"",
                tel:"",
                pw:""
            },
            // 1 密码登录 2 短信登录
            loginType:2,
            PwType:true,
            // 图形验证码
            verciftionShow:false,
            isPhoneNumber,
            timer:this.$store.getters.yzmTime
        }
    },
    watch: {
        isTime(){
            this.timer = this.$store.getters.yzmTime;
        }
    },
    computed:{
        isTime(){
            return this.$store.getters.yzmTime;
        }
    },
    created () {
        document.title = this.$t("dialogLogin.loginTxt");
        this.getArgeementType();
    },
    mounted () {
        that = this;
    },
    methods:{
        loginFun:_.throttle(()=>{
            that.popupShowNum++;
            if(that.popupShowNum>1){
                that.goLogin();
            }
        },500),
        callbackSubmit(){
            this.goLogin();
        },
        // 登录
        async goLogin(){
            let data;
            if(this.loginType == 1){
                if(!this.loginForm.pw){
                    this.$toast(this.$t("login.pleasePw"));
                    return false;
                }
                data = {
                    tel: this.loginForm.tel,
                    pw: md5(this.loginForm.pw)
                }
            }
            if(this.loginType == 2){
                if(!this.loginForm.telVerifyCode){
                    this.$toast(this.$t("login.pleaseyzm"));
                    return false;
                }
                data = {
                    tel: this.loginForm.tel,
                    telVerifyCode: this.loginForm.telVerifyCode
                }
            }
            const res = await this.$store.dispatch('user/login', data);
            if(res.errorCode == 0){
                if (this.$route.query.redirect) {
                    // console.log(this.$route.query.redirect);
                    window.location.href = this.$route.query.redirect
                } else {
                    this.$router.push('/')
                }
            }else{
                this.popupShowNum = 0;
                this.$toast.fail(res.errorMsg);
            }
        },
        // 查看协议
        seeTreaty(type){
            this.$router.push({path:'/user/agreement',query:{protocolType:type}})
        },
        // 去注册
        goRegist(){
            this.$router.replace({
                path:"/user/regist",
                query:{
                    redirect:this.$route.query.redirect,
                    tel:this.loginForm.tel
                }
            })
        },
        // 图形验证关闭回调
        verciftionclose(data){
            if(data.type == 1){
                this.verciftionShow = false;
                return false;
            }
            if(data.type == 2){
                this.sendverifyFun(data)
            }
            if(data.type == 3){
                this.sendverifyFun({})
            }
        },
        async sendverifyFun(data){
            const res = await verifyCode({
                tel:this.loginForm.tel,
                ...data
            })
            if(res.data.errorCode == 100001){
                this.$toast(res.errorMsg)
                setTimeout(()=>{
                    this.$refs.childverification.getImgYzmData();
                },500)
                return false;
            }else{
                if(res.data.errorCode == 0){
                    this.$toast(this.$t("login.yzmtosend"))
                    if(this.timer == this.$store.getters.yzmTime){
                        this.verciftionShow = false;
                        let time = setInterval(() => {
                            this.timer --;
                            this.verificationText = this.timer+'s';
                            if(this.timer == 1){
                                clearInterval(time)
                                this.verificationText = this.$t("login.sendverificatCode");
                                this.timer = this.$store.getters.yzmTime;
                            }
                        }, 1000);
                    }
                }
                this.verciftionShow = false;
            }
        },
        // 获取协议名称
        // 获取协议名字
        async getArgeementType(){
            let datadd = {};
            let result = await config_get(datadd);
            // console.log(result.data.errorCode);
            if(result.data.errorCode == 0){
                this.argeementTitle = result.data.data.regestProtocal.title;
                this.privacyTitle = result.data.data.privacy.title;
                this.tickType = result.data.data.regestProtocal.checked;
                this.hosptailName = result.data.data.tenantName
            }
        },
        // 获取图形验证码
        async sendverify(){
            if(this.timer == this.$store.getters.yzmTime){
                await this.$refs.loginForm.validate();
                //  console.log(this.$i18n.locale );
                try {
                    if(this.$i18n.locale == 'cxo'){
                        this.verciftionShow = true;
                        return false;
                    }
                    let r = await reg_check({
                        tel:this.loginForm.tel
                    })
                    if(r.data.errorCode == 0){
                        if(r.data.data == 0){
                            this.$dialog.alert({
                                title: '提示',
                                className:"regist",
                                message: '系统检测您是新用户，请立即注册',
                                confirmButtonText:"确定"
                            })
                            .then(() => {

                                this.$router.push({
                                    path:"/user/regist",
                                    query:{
                                        redirect:this.$route.query.redirect,
                                        tel:this.loginForm.tel,
                                        newType:1
                                    }
                                })
                            })
                        }else{
                            this.verciftionShow = true;
                        }
                    }
                } catch (error) {
                    console.log(error);
                    console.log(JSON.stringify(error))
                }

            }else{
                console.log(this.timer == this.$store.getters.yzmTime +'---'+ this.timer +'---'+ this.$store.getters)
                console.log(this.timer == this.$store.getters.yzmTime,this.timer , this.$store.getters);
            }
        }
    }
}
</script>

<style lang="less" scoped>
.login-container{
    height: 100%;
    width: 100%;
    background: url("~@/assets/user/login-back.png") no-repeat;
    background-size:  cover;
    overflow: auto;
    .login-banner{
        height: 6.6rem;
        margin: 0 1rem;
        background: url("~@/assets/user/login-banner-icon.png") no-repeat;
        background-size: 9rem 6.56rem;
        background-position:bottom right;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: flex-start;
        color: #000000;
        .title{
            font-size: 1rem;
            font-family: PingFangSC-Semibold, PingFang SC;
            font-weight: 600;
            line-height: 1.6rem;
            letter-spacing: 0.02rem;
        }
        .desc{
            font-size: 0.72rem;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            line-height: 1rem;
            margin-top: 0.4rem;
        }
    }
    .login-form{
        margin:0 0.3rem;
        padding: 0.4rem 0.7rem 1.8rem 0.7rem;
        background: url("~@/assets/user/form-back.png") no-repeat;
        background-size: 100% 100%;
        .form-container{
            background: #fff;
            padding: 0 1.2rem 1.2rem;
            border-radius: 0.52rem;
            .form-item{
                display: flex;
                align-items: center;
                border-bottom: 0.03rem solid #E5E7EC;
                padding:1.26rem 0 0.48rem 0;
                /deep/ .van-field{
                    padding: 0;
                    height: 0.84rem;
                    font-size: 0.56rem;
                    font-family: PingFangSC-Regular, PingFang SC;
                    font-weight: 400;
                    color: #999999;
                    flex: 1;
                }
                .verify-box{
                    font-size: 0.56rem;
                    margin-left: 0.2rem;
                    font-family: PingFangSC-Medium, PingFang SC;
                    font-weight: 500;
                    color: #49A7FF;
                    line-height: 0.8rem;
                    min-width: 2rem;
                    text-align: center;
                }
                .dislabelVerify{
                    opacity: 0.8;
                }
                .cipher{
                    width: 0.64rem;
                    height: 0.64rem;
                    padding: 0.1rem;
                    margin-left: 0.3rem;
                }
                .icon{
                    width: 0.68rem;
                    height: 0.68rem;
                    margin-right: 0.48rem;
                }
                .verify-box{
                    flex: 0 0 auto;
                    padding: 0 0.4rem;
                    border-left: 0.02rem solid #49A7FF;
                    margin-left: 0.4rem;
                }
            }
            .form-btn {
                margin: 0 auto;
                margin: 1rem 0 0.7rem 0;
                width: 100%;
                height: 1.76rem;
                .van-button {
                    font-size: 0.6rem;
                    width: 100%;
                    height: 100%;
                    border-radius: 0.88rem;
                }
            }
            .form-verify-login{
                display: flex;
                justify-content: space-between;
                align-items: center;
                p{
                    font-size: 0.52rem;
                    font-weight: 400;
                    color: #666666;
                    line-height: 0.74rem;
                }
            }
            .agrment-txt{
                text-align: center;
                margin-top: 2rem;
            }
        }
    }
    .agrment-bottom-txt{
        // text-align: center;
        font-size: 0.48rem;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #666666;
        padding: 0.6rem 1.6rem;
        line-height: 0.66rem;
        margin: 2rem auto;
        a{
            color: #49A7FF;
        }
    }
}

</style>
<style lang="scss" >
.regist{
    width: max-content;
    max-width: 80%;
    .van-dialog__header{
        font-size: 0.6rem;
        line-height:1.5rem;
    }
    .van-dialog__content{
        .van-dialog__message{
            line-height: 1.6rem;
        }
    }
    .van-dialog__footer{
        .van-button {
            height: 1.6rem;
            line-height: 1.6rem;
            color: #499fff;
        }
    }

}
</style>
